<template>
  <div class="activities-add-or-update">
    <el-dialog
      :title="activities.id == 0 ? '新增' : '查看'"
      :close-on-click-modal="false"
      :visible.sync="activitiesDialog"
      @close="dialogClose"
    >
      <!-- <div class="asd" v-for="index in activitiesList" :key="index"> -->
      <div class="" v-if="activitiesList.input">
        <div
          class="inp flex-row-start1"
          v-for="(item, index) in activitiesList.input"
          :key="index"
        >
          <div class="name">{{ item.name }}</div>
          <input
            :type="item.type"
            :placeholder="item.value"
            :pattern="item.pattern"
            disabled
          />
        </div>
      </div>
      <div class="" v-if="activitiesList.upload">
        <div
          class="inp flex-row-start1"
          v-for="(item, index) in activitiesList.upload"
          :key="index"
        >
          <div class="name">{{ item.name }}</div>
          <input
            :type="item.type"
            :placeholder="item.value"
            :pattern="item.pattern"
            disabled
          />
          <!-- <video-upload
                ref="videoUploaded"
                :videoList="preVideo"
              /> -->
        </div>
      </div>
      <!-- </div> -->
      <!-- 内层对话框 -->
    </el-dialog>
  </div>
</template>

<script>
// 引入 wangEditor
import wangEditor from "wangeditor";
// 引入过滤函数
import { showcontent } from "@/utils/method.js";
import VideoUpload from "@/views/modules/config/child-components/upload-test";
export default {
    components: {
    VideoUpload,
  },
  data() {
    const checkLink = (rule, value, callback) => {
      if (this.activities.actType === "1" && !value) {
        return callback(new Error("外链地址不能为空"));
      }
      callback();
    };
    return {
      // 控制活动赛事增加或更新弹框的显示与隐藏
      activitiesDialog: false,
      // 控制内层对话框的显示与隐藏
      innerVisible: false,
      // 添加或更新赛事相关参数
      activitiesList: "",
      activities: {
        id: null,
        sort: 0,
        name: "",
        thumb: "",
        actType: "",
        description: "",
        model: "",
        hotLabel: "",
        context: "",
        startTime: "",
        endTime: "",
        link: "",
      },
      // 日期时间选择器的绑定值
      dateTimeArr: [],
      uploadUrl: "",
      // 赛事标签列表
      tagList: [
        { name: "普通", id: "1" },
        { name: "最热", id: "2" },
        { name: "最新", id: "3" },
      ],
      // 赛事模式列表
      modelList: [
        { name: "常规模式", id: "1" },
        { name: "倒计时模式", id: "2" },
        { name: "预告模式", id: "3" },
      ],
      // 保存富文本实例
      editor: null,
      // 保存图片地址数组
      fileList: [],
      loading: false,
      // 表单验证规则
      activitiesRules: {
        name: [
          {
            required: true,
            message: "请输入活动名称",
            trigger: "blur",
          },
        ],
        startTime: [
          {
            required: true,
            message: "请输入活动开始时间和结束时间",
            trigger: "blur",
          },
        ],
        actType: [
          {
            required: true,
            message: "请选择活动类型",
            trigger: "change",
          },
        ],
        thumb: [
          {
            required: true,
            message: "请上传活动图片",
            trigger: "blur",
          },
        ],
        model: [
          {
            required: true,
            message: "请选择活动类型",
            trigger: "change",
          },
        ],
        context: [
          {
            required: true,
            message: "请输入活动内容",
            trigger: "change",
          },
        ],
        hotLabel: [
          {
            required: true,
            message: "请输入活动标签",
            trigger: "change",
          },
        ],
        link: [{ validator: checkLink, trigger: "blur" }],
      },
    };
  },
  watch: {
    "activities.actType": function (val) {
      if (val === "0") {
        this.activities.link = "";
      } else {
        this.activities.link;
      }
    },
  },
  methods: {
    // 初始化？？？
    init(id) {
      console.log(id);
      this.activities.id = id;
      this.activitiesDialog = true;
      this.$nextTick(() => {
        this.$ajaxGet(`/registrationTemplate/getById/open?id=${id}`).then(
          ({ data }) => {
            console.log("视频列表数据", data);
            if (data.code === 0) {
              this.loading = false;
              this.activitiesList = JSON.parse(showcontent(data.data.content));
              console.log(this.activitiesList);
              // this.activitiesTotal = parseInt(data.data.total);
            }
          }
        );
        // this.$refs.activitiesRef.resetFields();
        // this.uploadUrl = this.$http.adornUrl(
        //     `/image/upload/open?token=` + this.$cookie.get("token")
        // );
      });
      // if (this.activities.id != 0) {
      //     this.getDetailInfo(this.activities.id);
      // }
    },
    // 点击提交按钮触发事件
    newsSubmit() {
      console.log(this.activities);
      // debugger
      this.$refs["activitiesRef"].validate((valid) => {
        // debugger
        if (valid) {
          console.log(valid);
          this.$ajaxPost(
            `/activities/${
              this.activities.id === 0 ? "save/open" : "update/open"
            }`,
            {
              ...this.activities,
              id:
                this.activities.id === 0 ? null : parseInt(this.activities.id),
            }
          ).then(({ data }) => {
            if (data.code === 0) {
              this.activitiesDialog = false;
              // this.$emit("activitiesUpdated");
              this.$message.success("保存成功");
            } else {
              this.$message.error(
                `${this.activities.id == 0 ? "新增" : "修改"}失败！`
              );
            }
          });
        } else {
          return false;
        }
      });
    },
    openRichDialog() {
      this.innerVisible = true;
      if (!this.editor) {
        this.$nextTick(() => {
          // 创建富文本编辑器实例
          const editor = new wangEditor("#demo1");
          // 配置 onchange 回调函数，将数据同步到 vue 中
          editor.config.onchange = (newHtml) => {
            this.activities.context = newHtml;
          };
          editor.config.uploadImgServer = 'https://activity.suhoo.net/api/upload/image';
          editor.config.showLinkImg = false;
          editor.config.uploadImgShowBase64 = true;
          editor.config.uploadFileName = "file";
          /* editor.config.customUploadImg = function (
                        resultFiles,
                        insertImgFn
                    ) {
                        let reader = new FileReader();
                            reader.readAsDataURL(resultFiles[0]);
                            reader.onload = function (e) {
                                insertImgFn(e.target.result)
                            }
                    }; */
          editor.config.uploadImgHooks = {
            customInsert: function (insertImg, result, editor) {
				let url = (result.data.fileInfo.domain ? result.data.fileInfo.domain+'/' : 'https://activity.suhoo.net/')+result.data.fileInfo.file_path;
				insertImg(url);
            },
          };
          // 创建编辑器
          editor.create();
          if (this.activities.context !== "") {
            editor.txt.html(showcontent(showcontent(this.activities.context)));
            // editor.txt.html(this.activities.context);
          }
          this.editor = editor;
        });
      }
    },
    // 获取赛事详情
    getDetailInfo(id) {
      this.loading = true;
      this.$ajaxGet("/activities/info/open/" + id).then(({ data }) => {
        Object.keys(this.activities).forEach((key) => {
          this.activities[key] = data.data[key];
        });
        this.loading = false;
        this.dateTimeArr.push(this.activities.startTime);
        this.dateTimeArr.push(this.activities.endTime);

        // 将图片展示
        if (this.activities.thumb) {
          const obj = {
            url: this.activities.thumb,
          };
          this.fileList = [obj];
        }
        this.activities.context = showcontent(this.activities.context);
        this.activities.description = showcontent(this.activities.description);
      });
    },
    // 关闭弹框时触发事件
    dialogClose() {
      this.fileList = [];
      this.dateTimeArr = [];
      Object.keys(this.activities).forEach((key) => {
        if (key === "id") {
          this.activities[key] = null;
        } else if (key === "sort") {
          this.activities[key] = 0;
        } else {
          this.activities[key] = "";
        }
      });
      if (this.editor) {
        this.editor.destroy();
        this.editor = null;
      }
    },
    dateTimeChange(val) {
      if (val) {
        this.activities.startTime = val[0];
        this.activities.endTime = val[1];
      } else {
        this.activities.startTime = "";
        this.activities.endTime = "";
      }
    },
    // ==============图片上传相关方法=========

    // 从本地保存的上传目录中删除图片路径
    handleRemove() {
      this.activities.thumb = "";
    },
    handlePreview(file) {
      window.open(file.url, "_blank").location;
    },
    beforeUpload(file) {
      const isLt100M = file.size / 1024 / 1024 < 10;
      if (!isLt100M) {
        this.$message.error("上传文件大小不能超过 10MB!");
      }
      return isLt100M;
    },
    handleSuccess(response) {
      if (response && response.code === 0) {
        console.log(response);
        console.log("文件上传成功返回结果：", response.data);
	    let url = (response.data.fileInfo.domain ? response.data.fileInfo.domain+'/' : 'https://activity.suhoo.net/')+response.data.fileInfo.file_path;
        this.activities.thumb = url;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.el-row {
  display: flex;
  align-items: center;
  .el-col {
    display: flex;
    align-items: center;
  }
}
/deep/ .el-upload-list--picture {
  .el-upload-list__item {
    width: 92px;
    height: 92px;
  }
}
/deep/ .el-date-editor {
  height: 30px;
  line-height: 30px;
}
/deep/ .el-radio__label {
  color: #606266;
}
/deep/ .el-dialog__body {
  .el-form-item {
    margin-bottom: 10px;
  }
}
/deep/ .el-form-item__error {
  padding-top: 0;
}
.el-upload__tip {
  font-size: 12px;
}
.describe-activities {
  padding-top: 5px;
}
.top {
    text-align: left;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #323232;
}

.btn {
    // width: 60%;
    position: relative;
    bottom: 20px;
    margin: 30px 96px;
    padding: 6px 75px;
    border-radius: 4px;
    background: #4093FF;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
}

.cont {
    padding-bottom: 20px;
}

.Popup {
    position: relative;
    top: 0;
    right: 0;
    // width: 100%;
    // height: 100%;
    z-index: 2003;
    background: rgba(0, 0, 0, 0.5);
}

.beijing {


    .top {
        padding-top: 30px;
        font-size: 24px;
        font-family: AlibabaPuHuiTiB;
        color: #4093FF;
    }
}

/deep/.van-popup {
    background-color: transparent !important;

    img {
        width: 48px;
        height: 48px;
    }
}

.inp {
    // width: 100%;
    margin: 12px 23px;
    padding: 13px;
    border: 1px solid #CBD5E3;
    border-radius: 3px;

    .name {
        // margin-right: 44px;
        width: 56px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #858786;
    }

    input {
        margin-left: 30px;
        border: none;
        width: 120px;
        height: 14px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        // color: #C8C9CC;
        line-height: 14px;
    }

    // input:last-child {
    //     margin-left: 20px;
    //     width: 80px;
    // }

    img {
        width: 16px;
        height: 16px;

    }
}

.btntijioa {
    margin: 23px;
    padding: 16px 103px;
    background-color: #4093FF;
    border-radius: 11px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
}
</style>